@if (settings.showGearTierListMessage()) {
  <div class="info box reset-font" style="margin-bottom: 12px;">
    <div class="info-box-body">
      <div class="close-info-btn" (click)="hideInfoMessage()">✕</div>
      <h3 class="info-title">Explainer: <strong>Gear Tier List</strong></h3>
      <p>
        <app-content cid="gear-tiers" contentType="tip" [conditions]="{gearTierListTab: true, poe2: poe2}" style="display: inline-block;"></app-content>
      </p>
      <p>
        Note that <strong>Quivers, Wands, Staves and Sceptres</strong> don't have improved versions of the Basic Base Types, and thus their categorization is more opinionated. Review and adjust to your needs.
      </p>
      <p><a class="remove-warning-link" (click)="hideInfoMessage()">(I understand, dismiss)</a></p>
    </div>
  </div>
}

<div class="tier-list-info">
  <div class="tier-input">
    <span>
      <span>Item Class</span>
      <app-select class="inline" [searchable]="true" [alignLeft]="true" style="width: 200px" [disabled]="false" [(ngModel)]="itemClass" (selectedValueChange)="changeItemClass()">
        @for (class of itemClassList; track class) {
          <app-option [value]="class.type" [text]="class.type" [imgUrl]="class.image ? imgPrefix + class.image : ''" [alt]="class.type" [width]="'16px'" [height]="'16px'">
          </app-option>
        }
      </app-select>
    </span>

    @if (armourClasses.includes(itemClass) && itemClass !== 'Bucklers') {
      <span>
        <span>Defence Type</span>
        @if (itemClass === 'Shields') {
          <app-select class="inline" style="width: 100px" [disabled]="false" [(ngModel)]="defenceType" (selectedValueChange)="changeDefenceType()">
            @for (type of visibleDefenceTypesForShields; track type) {
              <app-option [value]="type" [text]="type"></app-option>
            }
          </app-select>
        } @else {
          <app-select class="inline" style="width: 100px" [disabled]="false" [(ngModel)]="defenceType" (selectedValueChange)="changeDefenceType()">
            @for (type of visibleDefenceTypes; track type) {
              <app-option [value]="type" [text]="type"></app-option>
            }
          </app-select>
        }
      </span>
    }

    @if (hasDropLevel && filter.showLevelingGear) {
      <span>
        <span filter-title text="Simulate Area Level" class="filter-title-inline">
          Simulate which items would be shown {{ poe1 ? 'when they have your specified Socket Group, or' : '' }} as <span class="normal-item-color">Normal</span>, <span class="magic-item-color">Magic</span> or <span class="rare-item-color">Rare</span>, and which would be hidden, based on the difference between their Drop Level and Area Level, if <strong>Leveling Gear</strong> were enabled on the Leveling Gear Quick Filters for this Weapon or Armour type.
        </span>

        <input type="number" placeholder="Level" maxlength="2" pattern="[0-9.,]*" inputmode="numeric" step="any" class="form-control minmax inline-input"
          [(ngModel)]="areaLevel" (ngModelChange)="rebuildGearTierDataVm()">

          @if (areaLevel) {
            <span class="extra-info">
              {{ areas[areaLevel] }}
            </span>
          }
      </span>
    }

    <span class="regular-checkbox my-gear-only-toggle">
      <span class="input-group-btn">
        <button class="btn toggle-btn" [class.off]="!settings.limitGearTierListToMyGear()" (click)="toggleMyGearOnly()"></button>
      </span>
      Limit to Favourite Gear only
      <app-tooltip-wrapper class="help-tooltip" [right]="!isMobile()">
        <span class="extra-info"> (?)</span>
        <ng-template #tooltip>Limits the Item Class and Defence Type dropdowns to gear configured in Favourite Gear or Leveling Gear. Does not change the Filter Output.</ng-template>
      </app-tooltip-wrapper>
    </span>
  </div>
</div>

<div class="tier-list-container">
  @if (selectedGearTierDataVm) {
  <div class="tier-list">
    @for (tier of selectedGearTierDataVm; track tier.tier) {
    <div class="tier"
         (dragenter)="onDragEnter($event, tier)"
         (dragover)="onDragOver($event)"
         (dragleave)="onDragLeave($event, tier)"
         (drop)="onDrop($event, tier)"
         [class.drag-over]="tier.isDragOver">
      <div class="tier-title {{ tier.tierStyle }}">
        <h3>{{ tier.tier }} <app-gear-tier-icon [tier]="tier.tier"></app-gear-tier-icon></h3>
      </div>
      @if (tier.tierSubtitle) {
        <div class="tier-subtitle">{{ tier.tierSubtitle }}</div>
      }
      <div class="tier-item-types normal-item-color">
        @for (item of tier.items; track item.name) {
        <div class="tier-item-type-base-type">
          <app-item-label
            [class.rare-item-color]="item.displayedAs === 'Rare'"
            [class.magic-item-color]="item.displayedAs === 'Magic'"
            [class.tier-hidden-color]="item.displayedAs === 'Never'"
            [gear]="true"
            [baseType]="item.name"
            [image]="item.image"
            [restricted]="item.restricted"
            [restrictedContent]="item.restrictedContent"
            [hideTooltip]="draggedItem?.name == item.name"
            draggable="true"
            (dragstart)="onDragStart($event, item)"
            (dragend)="onDragEnd()"
            [class.dragged]="draggedItem?.name === item.name"></app-item-label>
          @if (this.areaLevel) {
            @if (item.reason) {
              <span class="extra-info item-label-help" title="{{
                item.reason === 'DropLevelTooHigh'
                  ? 'Can not yet drop in this Area Level'
                  : item.reason === 'AreaLevelTooLow'
                    ? 'No longer shown in this Area Level'
                    : item.reason === 'AreaLevelTooHigh'
                      ? 'Leveling Weapons no longer active in this Area Level'
                      : item.reason === 'SpecialWeapon'
                        ? 'Caster Weapons & Quivers always shown'
                        : ''
                }}"> (?)</span>
            } @else if (item.displayedAs === 'Rare') {
              <span class="extra-info item-label-help" title="Only shown as Rare"> (?)</span>
              <app-equipment-tier-picker class="picker"
                [equipmentType]="EquipmentType.OtherGearLevelingRare"
                [active]="filter.showLevelingGearRare"
                [exampleName]="item.name"
                [rarity]="Rarity.Rare"></app-equipment-tier-picker>
            } @else if (item.displayedAs === 'Normal') {
              <span class="extra-info item-label-help" title="Shown as Normal"> (?)</span>
              <app-equipment-tier-picker class="picker"
                [equipmentType]="EquipmentType.OtherGearLevelingNormal"
                [active]="filter.showLevelingGearNormal"
                [exampleName]="item.name"></app-equipment-tier-picker>
            } @else if (item.displayedAs === 'Magic') {
              <span class="extra-info item-label-help" title="Shown as Magic"> (?)</span>
              <app-equipment-tier-picker class="picker"
                [equipmentType]="EquipmentType.OtherGearLevelingMagic"
                [active]="filter.showLevelingGearMagic"
                [exampleName]="item.name"
                [rarity]="Rarity.Magic"></app-equipment-tier-picker>
            } @else if (item.displayedAs === 'GoodSocketFirstAppearance') {
              <span class="extra-info item-label-help" title="Shown as Good Socketed (First Appearance) ({{ item.socketGroup || 'WWW' }})"> (?)</span>
              <app-equipment-tier-picker class="picker"
                [equipmentType]="EquipmentType.OtherGearLevelingGoodSocketedFirstAppearance"
                [active]="filter.showLevelingGearOtherSocketed"
                [exampleName]="item.name"
                [sockets]="'L' + (item.socketGroup || 'WWW')"></app-equipment-tier-picker>
            } @else if (item.displayedAs === 'GoodSocket') {
              <span class="extra-info item-label-help" title="Shown as Good Socketed ({{ item.socketGroup || 'WWW' }})"> (?)</span>
              <app-equipment-tier-picker class="picker"
                [equipmentType]="EquipmentType.OtherGearLevelingGoodSocketed"
                [active]="filter.showLevelingGearOtherSocketed"
                [exampleName]="item.name"
                [sockets]="'L' + (item.socketGroup || 'WWW')"></app-equipment-tier-picker>
            } @else if (item.displayedAs === 'ExcellentSocketFirstAppearance') {
              <span class="extra-info item-label-help" title="Shown as Excellent Socketed (First Appearance) ({{ item.socketGroup || 'WWWW' }})"> (?)</span>
              <app-equipment-tier-picker class="picker"
                [equipmentType]="EquipmentType.OtherGearLevelingExcellentSocketedFirstAppearance"
                [active]="filter.showLevelingGearExcellentSocketed"
                [exampleName]="item.name"
                [sockets]="'L' + (item.socketGroup || 'WWWW')"></app-equipment-tier-picker>
            } @else if (item.displayedAs === 'ExcellentSocket') {
              <span class="extra-info item-label-help" title="Shown as Excellent Socketed ({{ item.socketGroup || 'WWWW' }})"> (?)</span>
              <app-equipment-tier-picker class="picker"
                [equipmentType]="EquipmentType.OtherGearLevelingExcellentSocketed"
                [active]="filter.showLevelingGearExcellentSocketed"
                [exampleName]="item.name"
                [sockets]="'L' + (item.socketGroup || 'WWWW')"></app-equipment-tier-picker>
            }
          }
          @if (item.originalTier && item.originalTier !== tier.tier) {
            <span class="original-tier" (click)="resetToOriginalTier(item)"
                  title="Reset to original {{ item.originalTier }}-tier">↻</span>
          }
        </div>
        }
      </div>
    </div>
    }
  </div>
  }
</div>
